import React from 'react';
import { Modal, Card, Row, Col, Button, Spin, Tag, message } from 'antd';
import { ReloadOutlined, GoogleOutlined } from '@ant-design/icons';

const ReprocessModal = ({
  visible,
  setVisible,
  reprocessNew,
  reprocessAll,
  reprocessStatuses,
  reporcessStatusLoading,
  createGoogleOAuth,
}) => {
  //console.log(reprocessStatuses);
  return (
    <Modal
      title={`Paid Search Admin Tools`}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      width={700}
    >
      <Row type="flex" style={{ justifyContent: 'center' }}>
        {reporcessStatusLoading ? (
          <Spin />
        ) : (
          <>
            <Col xs={24} sm={12} md={11}>
              <Card title="Reprocess All">
                {reprocessStatuses.allStatus === 'PROCESSING' ||
                reprocessStatuses.allStatus === 'QUEUED' ||
                reprocessStatuses.allStatus === 'FAILED' ? (
                  <Row type="flex" justify="center" align="middle">
                    <Tag
                      color={
                        reprocessStatuses.allStatus === 'PROCESSING'
                          ? 'processing'
                          : reprocessStatuses.allStatus === 'FAILED'
                            ? 'error'
                            : reprocessStatuses.allStatus === 'QUEUED'
                              ? 'warning'
                              : 'success'
                      }
                      style={{ marginBottom: '25px' }}
                    >
                      {reprocessStatuses.allStatus}
                    </Tag>
                  </Row>
                ) : (
                  <></>
                )}

                <Row type="flex" justify="center" align="middle">
                  <ReloadOutlined style={{ fontSize: '80px', marginBottom: '20px' }} />
                  <div style={{ marginBottom: '20px' }}>
                    This will reprocess all available Paid Search
                  </div>
                  <Button
                    icon={<ReloadOutlined />}
                    disabled={
                      reprocessStatuses.allStatus === 'PROCESSING' ||
                      reprocessStatuses.allStatus === 'QUEUED'
                        ? true
                        : false
                    }
                    type="primary"
                    onClick={() => {
                      reprocessAll();
                    }}
                  >
                    Reprocess All Paid Search
                  </Button>
                </Row>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={11} offset={2}>
              <Card title="Process New">
                <Row type="flex" justify="center" align="middle">
                  <ReloadOutlined style={{ fontSize: '80px', marginBottom: '20px' }} />
                  <div style={{ marginBottom: '20px' }}>
                    This will only process paid search that has been newly added and and don't have
                    any existing data yet
                  </div>
                  <Button
                    icon={<ReloadOutlined />}
                    type="primary"
                    onClick={() => {
                      reprocessNew();
                    }}
                  >
                    Process New Paid Search
                  </Button>
                </Row>
              </Card>
            </Col>
          </>
        )}
      </Row>
      <Row type="flex" style={{ justifyContent: 'center', marginTop: '16px' }} gutter={[16, 16]}>
        <Col xs={24} sm={24} md={22}>
          <Card title="Google OAuth">
            <Row type="flex" justify="center" align="middle" style={{ flexDirection: 'column' }}>
              <GoogleOutlined
                style={{ fontSize: '48px', marginBottom: '16px', color: '#4285F4' }}
              />
              <div
                style={{ marginBottom: '16px', fontSize: '14px', color: '#666', fontWeight: '500' }}
              >
                Connect Google Account
              </div>
              <div
                style={{
                  marginBottom: '16px',
                  fontSize: '12px',
                  color: '#888',
                  textAlign: 'center',
                }}
              >
                Authorize Google OAuth to enable Google Ads integration for this organization
              </div>
              <Button
                icon={<GoogleOutlined />}
                type="primary"
                style={{ width: '100%' }}
                onClick={async () => {
                  try {
                    message.loading('Connecting to Google...');
                    await createGoogleOAuth();
                    message.success('Google OAuth created successfully');
                  } catch (err) {
                    message.error('Failed to create Google OAuth');
                  }
                }}
              >
                Sign in with Google
              </Button>
            </Row>
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export default ReprocessModal;
